export default "__VITE_ASSET__Bg$10lP1__"